// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DreamsList__container___wyhiF {
    margin: 10px 25px;
    /* display: flex;
    justify-content: center; */
}

.DreamsList__dreamRows___ZAyZD {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    text-align: left;
    width: 100%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DreamsList__container___wyhiF`,
	"dreamRows": `DreamsList__dreamRows___ZAyZD`
};
module.exports = ___CSS_LOADER_EXPORT___;
